export class UrpTagRequestDto {
  wetterCode: number;
  temperatur: string;
  beschrieb: string;
  detail: string;
}
